import React, {useState, useContext, useRef} from 'react'
import {
  Button,
  Container,
  Grid,
  Box,
  IconButton,
  Drawer,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
} from '@material-ui/core'
import FieldPreview from './BarcodeFieldPreview'
import FullScreenIcon from '@material-ui/icons/Fullscreen'
import FullScreenExitIcon from '@material-ui/icons/FullscreenExit'
import CancelIcon from '@material-ui/icons/CancelOutlined'
import {FaAngleDoubleUp, FaAngleDoubleDown} from 'react-icons/fa'
import {Mutation} from 'react-apollo'
import {sendFieldValueRequest} from '../../graphql/barcode/mutations/sendFieldValueMutation'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeFieldDrawer.styles'
import {ToastMessageContext} from '../../context/ToastMessage'
import _ from 'lodash'

export default function BarcodeFieldDrawer(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const [isNewDownload, setDownload] = React.useState(false)
  const [barcodeSettingRecord] = useState('')
  const refBtnGenerate = useRef(null)
  const toast = useContext(ToastMessageContext)

  const [formValues, setFormValues] = useState({
    totalGenerate: '1',
    startPosition: '1',
    totalRepeat: '1',
    maxPosition: '1',
  })

  function changePosition(value, maxPosition) {
    props.setStartPosition(value)
    setFormValues({
      ...formValues,
      startPosition: value,
      maxPosition: maxPosition,
    })
  }

  function generateMultipleFieldValue(sendFieldValueRequest, event) {
    if (props.itemsSelected.length === 0) {
      setDownload(false)
      toast.popMessage(t('barcode.wizard.value-drawer.select-record'), 'warning', event.target)
      return
    }

    setDownload(true)

    let ids = []
    props.itemsSelected.map(record => {
      return ids.push(record.id)
    })

    sendFieldValueRequest({
      variables: {
        startingPositionOnSheet: parseInt(formValues.startPosition),
        ids: ids,
        barcodeSettingId: parseInt(props.barcodeSettingId),
        token: props.token,
        userId: props.userId,
        userEmail: props.userEmail,
      },
    })
  }

  function fullPaperHeight(event) {
    props.setOpenDrawer(false)
  }

  function removeSelectedItems(event, data) {
    const selectedIndex = props.itemsSelected.indexOf(data)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(props.itemsSelected, data)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(props.itemsSelected.slice(1))
    } else if (selectedIndex === props.itemsSelected.length - 1) {
      newSelected = newSelected.concat(props.itemsSelected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        props.itemsSelected.slice(0, selectedIndex),
        props.itemsSelected.slice(selectedIndex + 1)
      )
    }
    props.setItemsSelected(newSelected)
  }

  function displayType(fieldDisplay, row) {
    if (row[fieldDisplay.key] === undefined || row[fieldDisplay.key] === null) {
      return '-'
    } else if (fieldDisplay.type === 'default_image') {
      return <img src={row['default_attachment']['url']} alt="default_attachment" />
    } else if (
      fieldDisplay.type === 'StatusField' ||
      fieldDisplay.type === 'ApUserField' ||
      fieldDisplay.type === 'EntityListField'
    ) {
      return _.truncate(row[fieldDisplay.key]['display_name'], {
        length: 8,
        omission: '...',
      })
    } else if (fieldDisplay.type === 'SignatureField') {
      return (
        <img src={row[fieldDisplay.key]} alt={fieldDisplay.key} style={{width: 50, height: 50}} />
      )
    } else if (fieldDisplay.type === 'MultipleEntityListField') {
      let values = ''
      Object.keys(row[fieldDisplay.key]).forEach(function(key) {
        if (values !== '') values = values + ', ' + row[fieldDisplay.key][key]['display_name']
        else values = row[fieldDisplay.key][key]['display_name']
      })
      return _.truncate(values, {
        length: 8,
        omission: '...',
      })
    } else {
      return _.truncate(row[fieldDisplay.key].toString(), {
        length: 8,
        omission: '...',
      })
    }
  }

  return (
    <div>
      <Drawer
        anchor="bottom"
        open={props.openDrawer}
        variant="persistent"
        PaperProps={{
          style: {
            marginBottom: window === window.parent ? '30px' : '0px',
            borderColor: 'black',
            minHeight: '100%',
          },
        }}
      >
        <Grid container>
          <Grid item xs={6}>
            <Box marginLeft={5} marginTop={1}>
              {props.itemsSelected ? props.itemsSelected.length : '0'}{' '}
              {t('barcode.wizard.value-drawer.item-selected')}
            </Box>
          </Grid>

          <Grid item xs={2}>
            <IconButton onClick={fullPaperHeight}>
              {props.openDrawer ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
            </IconButton>
          </Grid>
          <Grid container item xs={4} justify="flex-end">
            <Box marginRight={4} marginTop={2}>
              {t('barcode.wizard.value-drawer.start-position') + formValues.startPosition}
            </Box>

            <Mutation mutation={sendFieldValueRequest}>
              {(sendFieldValueRequest, {loading, data}) => {
                if (data && isNewDownload) {
                  setDownload(false)
                  if (
                    data.sendFieldValueRequest.errors.length === 1 &&
                    data.sendFieldValueRequest.pdfData.location.length > 0
                  ) {
                    window.location.href = `${data.sendFieldValueRequest.pdfData.location}`
                  } else {
                    toast.popMessage(
                      data.sendFieldValueRequest.errors[0],
                      'warning',
                      refBtnGenerate
                    )
                  }
                }

                return (
                  <Button
                    ref={refBtnGenerate}
                    onClick={e => generateMultipleFieldValue(sendFieldValueRequest, e)}
                    value="reset"
                    variant="contained"
                    color="primary"
                    className={classes.buttonLink}
                    style={{textTransform: 'none'}}
                  >
                    {loading ? (
                      <div>
                        {t('barcode.wizard.value-drawer.generating')}
                        <CircularProgress size={20} color="secondary" />
                      </div>
                    ) : (
                      t('barcode.wizard.value-drawer.generate')
                    )}
                  </Button>
                )
              }}
            </Mutation>

            <IconButton onClick={fullPaperHeight}>
              {props.openDrawer ? <FullScreenExitIcon /> : <FullScreenIcon />}
            </IconButton>
          </Grid>
          <Box marginLeft={2} marginBottom={2} />
          <Grid container>
            <Divider />
            <Grid item xs={6}>
              <Container>
                <div className={classes.root}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          padding="none"
                          classes={{paddingNone: classes.cancelButton}}
                        ></TableCell>
                        {props.displayFields.map((row, index) => {
                          if (
                            row.type === 'default_image' ||
                            row.type === null ||
                            row.type === 'SignatureField'
                          ) {
                            return null
                          } else {
                            return (
                              <TableCell key={row.key} align="left" padding="default">
                                <h9>{row.name}</h9>
                              </TableCell>
                            )
                          }
                        })}
                      </TableRow>
                    </TableHead>
                  </Table>
                  <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle" size="medium">
                      <TableBody>
                        {props.itemsSelected.map(row => (
                          <TableRow key={row.id}>
                            <TableCell padding="none" classes={{paddingNone: classes.cancelButton}}>
                              <IconButton onClick={e => removeSelectedItems(e, row)}>
                                <CancelIcon />
                              </IconButton>
                            </TableCell>
                            {props.displayFields.map((fieldDisplay, index) => {
                              if (
                                fieldDisplay.type === 'default_image' ||
                                fieldDisplay.type === null ||
                                fieldDisplay.type === 'SignatureField'
                              ) {
                                return null
                              } else {
                                return index === 0 ? (
                                  <TableCell
                                    key={row.id + index}
                                    component="th"
                                    id={row.id}
                                    scope="row"
                                    padding="default"
                                    align="left"
                                    classes={{root: classes.cellRoot}}
                                  >
                                    {displayType(fieldDisplay, row)}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    align="left"
                                    key={row.id + index}
                                    padding="default"
                                    classes={{root: classes.cellRoot}}
                                  >
                                    {displayType(fieldDisplay, row)}
                                  </TableCell>
                                )
                              }
                            })}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                  <Box marginBottom={15} />
                </div>
              </Container>
            </Grid>
            <Grid item xs={6}>
              <FieldPreview
                page="generate"
                barcodeStartPosition={formValues.startPosition}
                changePosition={changePosition}
                viewPNG={barcodeSettingRecord.output === 'PNG'}
                headerPerview="false"
              />
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
    </div>
  )
}
